module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/7.9562503b.png";